import React, {useEffect, useState} from 'react';
import {
  AppBar,
  Box, Button,
  CssBaseline, Drawer, Hidden, IconButton,
  Toolbar,
  Typography,
  useScrollTrigger,
  Zoom
} from '@mui/material';
import * as PropTypes from 'prop-types';
import './Header.scss';
import {Link} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {Menu} from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import CollectionsIcon from '@mui/icons-material/Collections';
import {Grid} from '@mui/joy';
import HeaderMenu from '../../../common/HeaderMenu/HeaderMenu';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';
import BookOnlineRoundedIcon from '@mui/icons-material/BookOnlineRounded';
import {useLocation} from 'react-router-dom';
import LockOpenIcon from '@mui/icons-material/LockOpen';

function ScrollTop(props) {
  const {children, window} = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined, disableHysteresis: true, threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor',);

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth', block: 'center',
      });
    }
  };

  return (<Zoom in={trigger}>
    <Box
      onClick={handleClick}
      role="presentation"
      sx={{position: 'fixed', bottom: 16, right: 16}}
    >
      {children}
    </Box>
  </Zoom>);
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired, /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const Logo = require('../../../assets/Images/DCDDLogo.png')
const drawerWidth = 240;

export default function Header(props) {
  const [user, setUser] = useState({});
  const [role, setRole] = useState({});
  const roleName = role?.name;
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const location = useLocation();
  const isBookYourTicketRoute = location.pathname.startsWith('/book-your-ticket');
  const isBookYourTicketDetailRoute = /^\/book-your-ticket\/.+/.test(location.pathname);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    const storedRole = localStorage.getItem('role');
    if (storedRole) {
      setRole(JSON.parse(storedRole));
    }
  }, []);

  const handleNavigate = () => {
    if (roleName === 'super_admin' || roleName === 'museum_chief') {
      navigate('/management/museums');
    } else if (roleName === 'curator') {
      navigate('/management/user-management');
    } else if (roleName === 'assistant') {
      navigate('/management/acquisition');
    } else if (roleName === 'interns' || roleName === 'volunteers') {
      navigate('/management/catalogue-artefacts');
    } else if (roleName === 'conservator') {
      navigate('/management/conservator');
    } else if (roleName === 'receptionist') {
      navigate('/management/fd-dashboard');
    } else {
      navigate('/');
    }
  }

  return (
    <React.Fragment>
      <CssBaseline/>
      <Box
        style={{
          position: 'sticky',
          top: 0,
          backgroundColor: trigger ? '#525252' : 'transparent',
          zIndex: 1100,
          boxShadow: trigger ? '0px 1px 5px rgba(0, 0, 0, 0.2)' : 'none',
        }}
      >
        <AppBar position={'static'} className={'box-shadow'}>
          <Toolbar className="headerContent">
            <Box sx={{display: 'flex', alignItems: 'center', ml: {sm: 6, xs: 2}}}>
              <img style={{margin: 12}} className="hand-cursor" width={77} onClick={() => navigate('/')} src={Logo}
                   alt="logo"/>
              <Box sx={{display: {lg: 'flex', md: 'flex', sm: 'none', xs: 'none'}}}>
                <Box className="flex list-type" navbar>
                  <Box>
                    <Link to="/" className="text-decoration-none">
                      <Typography className="header-mr" sx={{color: '#3D3D3D'}}>Reports</Typography>
                    </Link>
                  </Box>
                  <Box>
                    <Typography className="text-decoration-none">
                      <Typography className="header-mr hand-cursor" sx={{color: '#3D3D3D'}}>Help</Typography>
                    </Typography>
                  </Box>
                  <Box>
                    <Link to="/" className="text-decoration-none">
                      <Typography className="header-mr" sx={{color: '#3D3D3D'}}>Photo Gallery</Typography>
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
            {!user?.active &&
            <Hidden smUp={true}>
              <Grid container spacing={2}>
                <Grid item sm={6} xs={6}>
                  <Button startIcon={<BookOnlineRoundedIcon/>}
                          onClick={() => navigate('/login-with-ndi')} sx={{backgroundColor: '#616B88', color: '#fff'}}
                          variant={'contained'}
                          className={'text-capitalize'}>Tickets</Button>
                </Grid>
              </Grid>
            </Hidden>
            }
            {!user?.active &&
            <Hidden smDown={true}>
              <Grid container spacing={2}>
                <Grid item sm={6} xs={6}>
                  <Button startIcon={<BookOnlineRoundedIcon/>}
                          onClick={() => navigate('/login-with-ndi')} sx={{backgroundColor: '#616B88', color: '#fff'}}
                          variant={'contained'}
                          className={'text-capitalize'}>Tickets</Button>
                </Grid>
                <Grid item sm={6} xs={6}>
                  <Button startIcon={<KeyboardDoubleArrowRightRoundedIcon/>}
                          onClick={() => navigate('/login')} sx={{color: '#fff'}}
                          variant={'contained'}
                          className={'text-capitalize'}>
                    Login
                  </Button>
                </Grid>
              </Grid>
            </Hidden>
            }
            <IconButton
              sx={{display: {sm: 'inline', md: 'none'}}}
              variant="outlined" onClick={() => setOpen(true)}>
              <Menu fontSize={'large'}/>
            </IconButton>
            {(user?.active && roleName !== 'user' && !isBookYourTicketRoute) &&
            <Box className={'flex'}>
              <Button variant={'contained'}
                      startIcon={<DashboardCustomizeRoundedIcon/>}
                      onClick={handleNavigate}>Dashboard</Button>
            </Box>}

            {user?.active && isBookYourTicketRoute && (
              <Box className={'flex'}>
                {isBookYourTicketDetailRoute ? (
                  <Button
                    startIcon={<KeyboardDoubleArrowRightRoundedIcon/>}
                    onClick={() => navigate('/book-your-ticket')}
                    variant={'contained'}
                    className={'text-capitalize'}
                  >
                    Back
                  </Button>
                ) : null}
              </Box>
            )}
            {(user?.active && roleName === 'user') &&
            <Box className={'flex-cx-center'}>
              {!isBookYourTicketRoute && (
                <Button startIcon={<BookOnlineRoundedIcon/>}
                        onClick={() => navigate('/book-your-ticket')} sx={{backgroundColor: '#616B88'}}
                        variant={'contained'}
                        className={'text-capitalize'}>Your Tickets</Button>
              )}
              <HeaderMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} handleClick={handleClick}/>
              <KeyboardArrowDownRoundedIcon sx={{color: '#000'}} className={'hand-cursor'} onClick={handleClick}/>
            </Box>
            }
            <Drawer open={open}
                    onClose={() => setOpen(false)}
                    sx={{
                      '& .MuiDrawer-paper': {width: drawerWidth},
                    }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  ml: 2,
                  mt: 1,
                }}
              >
                <Box sx={{flexDirection: 'row'}}>
                  <Box className={'drawerImage'}>
                    <img className="hand-cursor" width={77} onClick={() => navigate('/')}
                         src={Logo}
                         alt="Lagtha logo"/>
                    <Typography sx={{mb: 2, fontWeight: 700}}>The Museums of Bhutan</Typography>
                    <Box className={'borderBottom'}/>
                  </Box>
                  <Box className="list-type" navbar>
                    <Box className={'flex'} alignItems={'center'}>
                      <AssessmentIcon/>
                      <Link to="/" className="text-decoration-none">
                        <Typography className="header-mr" sx={{color: '#000'}}>Reports</Typography>
                      </Link>
                    </Box>
                    <Box className={'flex'} alignItems={'center'}>
                      <HelpCenterIcon/>
                      <Typography className="text-decoration-none">
                        <Typography className="header-mr hand-cursor" sx={{color: '#000'}}>Help</Typography>
                      </Typography>
                    </Box>
                    <Box className={'flex'} alignItems={'center'}>
                      <CollectionsIcon/>
                      <Link to="/" className="text-decoration-none">
                        <Typography className="header-mr" sx={{color: '#000'}}>Photo Gallery</Typography>
                      </Link>
                    </Box>
                    <Box className={'flex'} alignItems={'center'}>
                      <LockOpenIcon/>
                      <Box onClick={() => navigate('/login')} className="text-decoration-none">
                        <Typography className="header-mr" sx={{color: '#000'}}>Login</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          </Toolbar>
        </AppBar>
      </Box>
    </React.Fragment>
  );
}
